import { useCallback, useEffect, useState } from "react";

/**
 * #119: a transient "Saved" / "Done" confirmation that auto-dismisses after ~5s.
 * The lasting record lives in the audit log — the inline flash is just immediate
 * feedback, not a permanent status. Shared by every card that confirms a save
 * (CUEC, control exception, bridge, …).
 *
 * Usage: `const [savedAt, flashSaved] = useSavedFlash();` then call `flashSaved()`
 * after a successful save and render the indicator while `savedAt` is non-null.
 */
export function useSavedFlash(ms = 5000): [number | null, () => void] {
  const [savedAt, setSavedAt] = useState<number | null>(null);
  useEffect(() => {
    if (savedAt === null) return;
    const t = setTimeout(() => setSavedAt(null), ms);
    return () => clearTimeout(t);
  }, [savedAt, ms]);
  const flashSaved = useCallback(() => setSavedAt(Date.now()), []);
  return [savedAt, flashSaved];
}
